module.exports = __webpack_public_path__ + "static/media/down-arrow.7d136f3c.svg";